import { Component, OnInit, Input } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { ActivatedRoute } from "@angular/router";
import { Service } from "../../../../../models/service";
import { ServiceControllerService } from "../../../../../services/service-controller/service-controller.service";
import { ServiceProperties } from "../../../../../models/service-properties";
import { TranslatedBaseError } from "../../../../pages/TranslatedBaseError";
import { TranslateService } from "@ngx-translate/core";
import { FormControllerService } from "../../../../../services/form-controller/form-controller.service";
import { RecoverOrphanConfig } from "../../../../../models/recover-orphan-config";

@Component({
  selector: "service-settings-debug",
  templateUrl: "./service-settings-debug.component.html",
  providers: [ServiceControllerService, ToastrService, FormControllerService],
})
export class ServiceSettingsDebugComponent extends TranslatedBaseError implements OnInit {
  public serviceId: string;
  @Input() public service: Service;
  public services: any[];
  public isLoading: boolean = false;
  public loadChecking: boolean = false;

  public duplicatedKeys: any[] = [];

  constructor(private serviceControllerService: ServiceControllerService,
              public toastr: ToastrService,
              public translateService: TranslateService,
              private formControllerService: FormControllerService,
              private route: ActivatedRoute) {
                super(toastr, translateService);
              }

  public ngOnInit(): void {
    if (!this.service?.id || !this.service) {
      this.route.parent.params.subscribe((params) => {
        this.serviceId = (params.serviceId === "new") ? null : params.serviceId;
        if (this.serviceId !== null) {
          this.loadService();
        } else {
          this.service = new Service();
        }
      });
    } else {
      this.serviceId = this.service.id;
      if (!this.service.serviceJsonProperties) {
        this.service.serviceJsonProperties = new ServiceProperties();
      }
      if (this.service.serviceJsonProperties.enableDuplicatedKeysVerification) {
        this.checkDuplicatedKeys();
      }
    }
  }

  public saveService() {
    if (!this.isLoading) {
      this.isLoading = true;
      this.serviceControllerService.saveService(this.service, null).subscribe(
        (data) => {
          this.responseSuccessful("Publishing options saved");
        },
        (error) => this.showErrorMessage(error),
        () => this.isLoading = false,
      );
    }
  }

  public loadService() {
    this.serviceControllerService.getService(this.serviceId).subscribe(
      (data: Service) => {
        this.service = data;
        if (!data.serviceJsonProperties) {
          this.service.serviceJsonProperties = new ServiceProperties();
        }
        if (this.service.serviceJsonProperties.enableDuplicatedKeysVerification) {
          this.checkDuplicatedKeys();
        }
      },
    );
  }

  public onChange(event, block: string) {
    this.autoSave(block);
  }

  public autoSave(block: string) {
    switch (block) {
      case "Guide":
      case "Pages":
      case "Buttons":
      case "Publishing":
        this.saveService();
        break;
      default:
        break;
    }
  }
  public onDebugResultsUpdated(results: RecoverOrphanConfig[]): void {
    // Handle debug results update if needed
    // This can be used to perform additional actions when debug results are received
    console.log('Debug results updated:', results);
  }

  public checkDuplicatedKeys() {
    if (this.service.serviceJsonProperties.enableDuplicatedKeysVerification) {
      this.duplicatedKeys = [];
      this.formControllerService.getFlattenFormFields(this.serviceId).subscribe(
        (data) => {
          data.forEach((c) => {
            const occurences = data.filter((d) => d.key === c.key);
            if (occurences && occurences.length > 1) {
              const duplicatedOccurences = this.duplicatedKeys.find((d) => d.key === c.key);
              if (duplicatedOccurences) {
                duplicatedOccurences.occurences.push(c);
              } else {
                this.duplicatedKeys.push({
                  key: c.key,
                  occurences: [c],
                });
              }
            }
          });
        },
      );
    }
  }
}
